// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_sFA7u {
  width: 400px;
  position: relative;
  background-color: white;
  height: 80dvh;
}

@media (max-width:480px) {
  .container_sFA7u {
    width: auto;
    height: 100dvh;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/view/CreateUpdateItem.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE;IACE,WAAW;IACX,cAAc;EAChB;AACF","sourcesContent":[".container {\n  width: 400px;\n  position: relative;\n  background-color: white;\n  height: 80dvh;\n}\n\n@media (max-width:480px) {\n  .container {\n    width: auto;\n    height: 100dvh;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_sFA7u`
};
export default ___CSS_LOADER_EXPORT___;
